"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.highlightKeyword = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _react = _interopRequireDefault(require("react"));
/**
 * 高亮搜索关键字
 * @param {String} str 选项的文本
 * @param {String} keyword 关键字
 * @param {String} prefixCls 前缀
 * @returns ReactNodes
 */
var highlightKeyword = exports.highlightKeyword = function highlightKeyword(str, keyword, prefixCls) {
  var lowerKeyword = (keyword || '').toLowerCase();
  var type = (0, _typeof2.default)(str);
  if ((type === 'string' || type === 'number') && lowerKeyword) {
    var cells = String(str).toLowerCase().split(lowerKeyword).reduce(function (list, cur, index) {
      return index === 0 ? [cur] : [].concat((0, _toConsumableArray2.default)(list), [lowerKeyword, cur]);
    }, []);
    var fillCells = [];
    var start = 0;
    cells.forEach(function (cell, index) {
      var end = start + cell.length;
      var originWorld = str.slice(start, end);
      start = end;
      if (index % 2 === 1) {
        originWorld =
        /*#__PURE__*/
        // eslint-disable-next-line react/no-array-index-key
        _react.default.createElement("span", {
          key: index,
          className: "".concat(prefixCls, "-item-keyword")
        }, originWorld);
      }
      fillCells.push(originWorld);
    });
    return fillCells;
  }
  return str;
};